import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { RoleEnum } from '@/api/rest/resources/types/membership';
import { ComplianceFrameworks } from '@/api/rest/resources/types/organization';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUser } from '@/lib/auth';

import { FormCardFieldMultipleChoice } from './form/FormCardField';
import { FORM_FIELD_NAMES } from './form/OnboardingForm';
import { SectionHeader } from './Section';

const offeredComplianceFrameworks = Object.keys(ComplianceFrameworks).filter(
  (framework) => !['science', 'greenhouse'].includes(framework),
);

export const OnboardingGoalsCompliance = () => {
  const { t } = useTranslation();

  const user = useUser();
  const isAdmin = user.membership.role === RoleEnum.admin;
  const isStaff = useIsStaffUser();

  return (
    <Stack spacing={12}>
      <SectionHeader i18nPath='shared.onboarding.goalsCompliance.description' />
      <Stack spacing={4}>
        {offeredComplianceFrameworks.map((framework) => (
          <FormCardFieldMultipleChoice
            key={`compliance-goal-${framework}`}
            title={t(
              `shared.complianceFrameworks.complianceFrameworks.${framework as keyof typeof ComplianceFrameworks}.title`,
            )}
            description={t(
              `shared.complianceFrameworks.complianceFrameworks.${framework as keyof typeof ComplianceFrameworks}.description`,
            )}
            formField={FORM_FIELD_NAMES.GOALS_COMPLIANCE}
            formValue={framework}
            isMultipleChoice={true}
            disabled={!isAdmin && !isStaff}
          />
        ))}
      </Stack>
    </Stack>
  );
};
